import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const MFB = ({ currentActivity, mfbSelections }) => {
  console.log("Current Activity:", currentActivity);
  console.log("MFB Selections:", mfbSelections);

  // Extract user selections (Convert from object array to string array)
  const userSelections = Object.values(mfbSelections || {});

  // Extract correct answers from JSON (first word before `/`)
  const correctAnswers = currentActivity.Options[0].Value.split(" ")
    .map((chunk) => (chunk.includes("/") ? chunk.split("/")[0] : null))
    .filter(Boolean);

  console.log("User Selections:", userSelections);
  console.log("Correct Answers:", correctAnswers);

  // Extract values from objects in userSelections (if necessary)
  const extractedUserSelections = userSelections.map(
    (obj) => Object.values(obj)[0]
  );

  console.log("Extracted User Selections:", extractedUserSelections);

  // Check if the user's selection matches the correct answer
  const isCorrect =
    JSON.stringify(extractedUserSelections) === JSON.stringify(correctAnswers);

  // Extract rationales (filter out empty ones)
  const rationaleTexts = currentActivity.Options.map(
    (option) => option.Rationale?.Text
  ).filter(Boolean);

  const rationaleContentIds = currentActivity.Options.filter(
    (option) => !option.Rationale?.Text?.trim() && option.Rationale?.ContentId
  ).map((option) => option.Rationale.ContentId.trim());

  return (
    <>
      {isCorrect ? (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Correct Answer!
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Incorrect Answer!
          </Typography>
        </>
      )}

      {/* Enhanced Rationale Display */}
      {rationaleTexts.length > 0 || rationaleContentIds.length > 0 ? (
        <Box
          sx={{
            marginTop: 1,
            fontSize: "0.75rem",
            color: "text.secondary",
            padding: "8px",
            margin: "8px 0",
          }}
        >
          <Typography component="div" sx={{ fontWeight: "bold" }}>
            Rationale:
          </Typography>
          {rationaleTexts.map((text, index) => (
            <Typography key={`text-${index}`}>{text}</Typography>
          ))}
          {rationaleContentIds.map((id, index) => (
            <Typography key={`cid-${index}`}>
              Refer to content ID: {id}
            </Typography>
          ))}
        </Box>
      ) : (
        <Typography
          sx={{
            fontSize: "0.9rem",
            fontStyle: "italic",
            color: "#999",
            marginTop: 1,
          }}
        >
          Rationale: Not available
        </Typography>
      )}
    </>
  );
};

export default MFB;
